import { render, staticRenderFns } from "./JjFormFootBtn.vue?vue&type=template&id=08cbb2c7&scoped=true"
import script from "./JjFormFootBtn.vue?vue&type=script&lang=js"
export * from "./JjFormFootBtn.vue?vue&type=script&lang=js"
import style0 from "./JjFormFootBtn.vue?vue&type=style&index=0&id=08cbb2c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cbb2c7",
  null
  
)

export default component.exports